import * as React from 'react';
import { FontAwesomeIcon } from './helpers/FontAwesomeIcon'
import { faPencilAlt } from '@fortawesome/free-solid-svg-icons'

export const EditIcon = (props: { color: string, size?: number, }) => {
  return (
    <FontAwesomeIcon icon={faPencilAlt} color={props.color} />
  )
}
